// extracted by mini-css-extract-plugin
export default {"productDetails":"product_productDetails__TwsEG","productDetails__container":"product_productDetails__container__Rluk7"};